import { COMPARADOR_OPEN_MODAL_FORM } from './constants'
import initialState from './initialState'

export function handleOpenModalForm(openModalForm) {
    return {
        type: COMPARADOR_OPEN_MODAL_FORM,
        openModalForm
    }
}

export function reducer(state = initialState, action) {
    const { openModalForm, type } = action

    if (type === COMPARADOR_OPEN_MODAL_FORM) {
        return {
            ...state,
            openModalForm
        }
    } else {
        return state
    }
}
